module.exports = "img/icon_context_low_on.bb2628b.svg";